import { createContext, useContext } from 'react'

export interface ChatFilesValue {
  files: Array<File>
  setFiles: React.Dispatch<React.SetStateAction<Array<File>>>
}

export const ChatFilesContext = createContext<ChatFilesValue | undefined>(undefined)

export function useChatFiles(): ChatFilesValue {
  const ctx = useContext(ChatFilesContext)
  if (!ctx) throw new Error('useChatFiles must be used within TripPlannerChatProvider')
  return ctx
}
